/*
 * CompUK 3D card tilt — pointer-tracked tilt for [data-cuk-tilt] hosts.
 * One delegated listener, rAF-throttled; bails on touch/coarse pointers,
 * reduced motion, and the theme editor. The transform itself lives in
 * app.css (.cuk-card-tilt.is-tilting) so removing .is-tilting eases the card
 * home on the host's resting transition.
 */
(function () {
  if (window.Shopify && window.Shopify.designMode) return;
  if (!window.matchMedia || !window.requestAnimationFrame) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var MAX_DEG = 6;
  var LIFT = '-4px';
  var active = null;
  var raf = 0;
  var lastX = 0;
  var lastY = 0;

  function apply() {
    raf = 0;
    if (!active) return;
    var r = active.getBoundingClientRect();
    if (!r.width || !r.height) return;
    var px = (lastX - r.left) / r.width - 0.5;
    var py = (lastY - r.top) / r.height - 0.5;
    var rx = Math.max(-MAX_DEG, Math.min(MAX_DEG, -py * MAX_DEG * 2));
    var ry = Math.max(-MAX_DEG, Math.min(MAX_DEG, px * MAX_DEG * 2));
    active.style.setProperty('--cuk-tilt-x', rx.toFixed(2) + 'deg');
    active.style.setProperty('--cuk-tilt-y', ry.toFixed(2) + 'deg');
    active.style.setProperty('--cuk-tilt-lift', LIFT);
  }

  function release(el) {
    if (!el) return;
    el.classList.remove('is-tilting');
    el.style.removeProperty('--cuk-tilt-x');
    el.style.removeProperty('--cuk-tilt-y');
    el.style.removeProperty('--cuk-tilt-lift');
  }

  document.addEventListener(
    'pointermove',
    function (e) {
      var host = e.target && e.target.closest ? e.target.closest('[data-cuk-tilt]') : null;
      if (host !== active) {
        release(active);
        active = host;
        if (active) active.classList.add('is-tilting');
      }
      if (!active) return;
      lastX = e.clientX;
      lastY = e.clientY;
      if (!raf) raf = window.requestAnimationFrame(apply);
    },
    { passive: true }
  );

  document.addEventListener(
    'pointerout',
    function (e) {
      if (!active) return;
      var to = e.relatedTarget;
      if (!to || !active.contains(to)) {
        release(active);
        active = null;
      }
    },
    { passive: true }
  );
})();
